export default "<div class=\"grid\">\n  <app-flag-icon [code]=\"iso\"></app-flag-icon>\n  <mat-label>{{ name }}</mat-label>\n</div>\n";